import { useTypedSelector } from 'builder/hooks/useTypedSelector'
import { selectors as userSelectors } from 'builder/modules/user'
import { useFeaturesConfig } from './featureConfig/useFeaturesConfig'

export const useRemainingAiResumeReviewFreeAttempts = () => {
  const isPremiumUser = useTypedSelector(userSelectors.premiumAccess)
  const aiResumeReviewFreeAttempts = useTypedSelector(userSelectors.aiResumeReviewFreeAttempts)
  const { features } = useFeaturesConfig()

  if (isPremiumUser || features.rbpAiReviewUnlim) {
    return Infinity
  }

  return aiResumeReviewFreeAttempts || 0
}
